var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
$("#myDiagramDiv").on("click", function (e) {
  $(this).addClass("infocus");
});

class CheckChromeExtension {
  async checkExtensionInstalled() {
    const extensionId = "gfkbgobhanlkdnnpgngngaiflelmhejm";
    try {
      await fetch(`chrome-extension://${extensionId}/logo/arxena-icon.png`);
      console.log("This happened");
      return true;
    } catch (e) {
      if (e?.message?.includes("signed out")) {
        new PageContents().tokenExpireAction();
      }
      // console.log("This happened catch")
      if (e instanceof TypeError && e.message == "Failed to fetch") {
        console.log("This happened Failed to ");
        return false;
      } else {
        throw e;
      }
    }
  }
  // Then in your site's buisness logic, do something like this
  async getExtensionStatus() {
    // var checkInstalledExtension = await this.checkExtensionInstalled();
    // console.log("This iss checkInstalledExtension::", checkInstalledExtension);
    // return checkInstalledExtension;
    let userObject = JSON.parse(localStorage["user"]);
    return userObject.hasOwnProperty("chrome_extension_id") && !!userObject.chrome_extension_id;
  }

  checkExtensionBySendingRequestToExtensionAndBackground() {
    // Not being used
    var hasExtension = false;
    const extensionId = localStorage["arx_chrome_ext_id"];
    var requiredVersion = 0;

    chrome.runtime.sendMessage(extensionId, { message: "version" }, function (reply) {
      if (reply) {
        if (reply.version) {
          if (reply.version >= requiredVersion) {
            hasExtension = true;
          }
        }
      } else {
        hasExtension = false;
      }
      console.log("This has extension:", hasExtension);
    });
  }
  sendMessageToContentFromOrgChart(token) {
    let data = { type: "setExtensionId", token };
    window.postMessage(data, base_url);
  }
}

class Iframes {
  removeIframe() {
    document.getElementById("your-extension-iframe").remove();
  }

  getIframeLoaded() {
    var data = {
      type: "LOAD_IFRAME",
      text: "PANDA IFRAME",
      columns: { dodod: "darata", toto: "Tata" },
    };
    window.postMessage(data, base_url);
  }
}

// setTimeout("removeIframe()",2000)

window.addEventListener("message", function (event) {
  // console.log("Window LIstener recived message::", event)
  if (event.data.type && event.data.type == "FROM_IFRAME") {
    console.log("Received event from iframe in main site :: ", event.data);
  }
  // console.log(Array.from(document.querySelectorAll('script')).map(x=> x.src))
});

$("#sortable").sortable({
  update: function (event, ui) {
    var sortedItems = $("#sortable").sortable("toArray");
    let statuses = JSON.parse(sessionStorage["statuses"]);
    console.log({ sortedItems });
    $("#sortable div").each(function (index, element) {
      // var text = $( this ).text();
      // console.log( { index, name: element.getAttribute( "data-object" ), title: element.id } );
      statuses = statuses.map((x) => (x.status_value == element.id ? { ...x, progress_value: index + 1 } : x));
    });
    console.log(statuses);
    sessionStorage["statuses"] = JSON.stringify(statuses);
  },
});
$("#sortable").disableSelection();


export { CheckChromeExtension, Iframes };
if (typeof window !== 'undefined') {
  window.CheckChromeExtension = CheckChromeExtension;
  window.Iframes = Iframes;
}
